/* esm.sh - three-mesh-bvh@0.9.10/src/utils/PrimitivePool */
export * from "/*three-mesh-bvh@0.9.10/esnext/src/utils/PrimitivePool.mjs";
